import React from "react";
import { Route, Routes as Switch, Navigate as Redirect, Outlet } from "react-router-dom";
import FoodProfiles from "./pages/FoodProfiles/FoodProfiles";
import Reports from "@pages/Reports/Reports";
import InstantCharts from "@pages/InstantCharts/InstantCharts";
import FoodProfile from "@pages/FoodProfile/FoodProfile";
import Home from "@pages/Home/Home";
import MenuExamples from "@pages/MenuExamples/MenuExamples";
import Byo from "@pages/Byo";
import TopTrends from "@pages/TopTrends";
import { RestaurantMenuProvider } from "@vms/RestaurantMenu";
import SelectFiltersProvider from "@vms/SelectFilters/SelectFiltersContext";
import { Routes } from "@routes";
import { AiSearchSettingsContextProvider } from "@vms/AiSearchSettingsContext/AiSearchSettingsContext";
import AiSearch from "@pages/AiSearch/AiSearch";

const SharedClientLayout = () => {
    return (
        <RestaurantMenuProvider>
            <SelectFiltersProvider>
                <AiSearchSettingsContextProvider>
                    <Outlet/>
                </AiSearchSettingsContextProvider>
            </SelectFiltersProvider>
        </RestaurantMenuProvider>
    );
};

const RoutesContainer = () => {
    return (
        <div>
            <Switch>
                <Route element={<SharedClientLayout/>}>
                    <Route path={Routes.aiSearch} element={<AiSearch/>}/>
                    <Route path={Routes.Home} element={<Home/>}/>
                    <Route path={Routes.byo} element={<Byo/>}/>
                    <Route path={Routes.byoSetting} element={<Byo/>}/>
                    <Route path={Routes.instantChart} element={<Byo/>}/>
                    <Route path={Routes.topTrends} element={<TopTrends/>}/>
                    <Route path={Routes.foodProfiles} element={<FoodProfiles/>}/>
                    <Route path={Routes.foodProfile} element={<FoodProfile/>}/>
                    <Route path={Routes.instantCharts} element={<InstantCharts/>}/>
                    <Route path={Routes.instantChartsNew} element={<InstantCharts/>}/>
                    <Route path={Routes.menuExamples} element={<MenuExamples/>}/>
                    <Route path={Routes.reports} element={<Reports/>}/>
                </Route>

                <Route path="*" element={<Redirect to={Routes.Home}/>}/>
            </Switch>
        </div>
    );
};

export default RoutesContainer;
